import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useGroupSpaceTypeChartStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalM),
    position: 'relative',
  },
  filterRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    ...shorthands.padding(0, 0, tokens.spacingVerticalS, 0),
  },
  filterRowSmall: {
    '@media (max-width: 768px)': {
      justifyContent: 'stretch',
    },
  },
  dropdown: {
    minWidth: '180px',
  },
});
